import * as Vue from "vue";
import {Component, Watch} from "vue-property-decorator";
import "./sidebar.styl";
import {eventBus, signalNames} from "../../../bus";
import {RouterManager, Routes} from "../../../router";
import {UserStatus} from "../../../models/userStatus";
const template = require("./sidebar.vue");

@Component({
  template: template
})
export class SidebarComponent extends Vue {

  mini = false;
  isSidebarOpen = false;
  sections = [
    {
      icon: "speaker_phone",
      title: "Automations",
      routes: [Routes.automations, Routes.automationDetail],
      action: () => RouterManager.instance.router.push(Routes.automations),
      isActive: false
    },
    {
      icon: "person",
      title: "Utenti",
      routes: [Routes.users, Routes.userDetail],
      action: () => RouterManager.instance.router.push(Routes.users),
      isActive: false
    },
    {
      icon: "perm_identity",
      title: "Installatori",
      routes: [Routes.installers, Routes.installerDetail],
      action: () => RouterManager.instance.router.push(Routes.installers),
      isActive: false
    }
  ];

  private created() {
    if ( this.$store.state.session.status === UserStatus.LoggedIn ) {
      this.isSidebarOpen = true;
    }
    eventBus.$on(signalNames.changeSidebarStatus, () => setTimeout(() => this.isSidebarOpen = !this.isSidebarOpen, 0));
    this.onRouteChange();
  }

  getEmail(): string {
    return this.$store.state.session.user.email;
  }
  getEmailFirstLetter(): string {
    return this.$store.state.session.user.email.charAt(0);
  }

  @Watch("$route")
  onRouteChange() {
    this.sections.forEach(section => {
      section.isActive = false;
      console.log("sections:", section.routes);
      section.routes.forEach(route => {

        console.log("sections:", route.name, this.$route.name);
        if (route.name === this.$route.name) {
          section.isActive = true;
        }
      });
    });
  }


}

Vue.component("cmSidebar", SidebarComponent);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/plain/sidebar/sidebar.ts